// extracted by mini-css-extract-plugin
export var formContainer = "_ji-0";
export var message = "_ji-1";